import { TEAM_FALLBACK_IMAGE } from '../shared/assets';
import './team.css';

const DARK_BG_CSS_CLASSES = [
  'bg-primary-dark-1',
  'bg-primary-dark-2',
  'bg-primary-dark-3'
];

const dummyPara = "Our aim at NRNA Australia is to unite all Non-Resident Nepali (NRNs) people and Nepalese organizations throughout the Australia under one umbrella organization to form a unified and institutional movement to achieve the mutual benefit between all NRNs and people of Nepali origin in Australia. At the same time, to be inclusive in this multicultural Australia by promoting Nepalese culture at the same time embracing other cultures and respecting the values and law of Australia. In addition to this, NRNA Australia also looks at the interest of second-generation people of Nepali origin and beyond.";
const TeamMember = ({ person }) => {

  const randomBg = DARK_BG_CSS_CLASSES[Math.floor(Math.random() * Math.floor(3))];
  return <article class={`team-member-grid-item ${randomBg}`}>
    <img className="team-member-image"
      src={person.image?.details?.url || TEAM_FALLBACK_IMAGE}
      alt={`${person.fullName} - ${person.designation}, NRNA Australia`}
    />
    <h3 className="team-member-name">{person.fullName}</h3>
    <div className="team-member-divider" />
    <div className="team-member-title">
      {person.designation}{person.officeState && <><br />{person.officeState}</>}
    </div>
  </article>
    ;
};


export default ({ team }) => {
  if (!team) {
    return <></>;
  }
  return <section className="team-section">
    {dummyPara}
    <h2>{team.officeName}</h2>
    <h3>{team.officeTerm}</h3>
    <div className="team-grid-container">
      {
        team.officeBearerList.map(person => <TeamMember person={person} />)
      }
    </div>
  </section>;
}



